import { render, staticRenderFns } from "./AddResidentComplex.vue?vue&type=template&id=5d224131"
import script from "./AddResidentComplex.vue?vue&type=script&lang=js"
export * from "./AddResidentComplex.vue?vue&type=script&lang=js"
import style0 from "./AddResidentComplex.vue?vue&type=style&index=0&id=5d224131&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports